import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-night" data-id="element-59" data-mp="1lc231ky1rhuv">
      <div className="mx-auto max-w-content px-6 py-16 lg:py-24" data-id="element-60" data-mp="1gcxsapvh5c2f">
        <h2 className="text-center font-display text-3xl font-semibold uppercase tracking-tight text-parchment sm:text-4xl" data-id="element-61" data-mp="1gal1dn7qnrd8">
          ❓ Lo que más nos preguntan
        </h2>

        <div className="mx-auto mt-10 max-w-3xl space-y-3" data-id="element-62" data-mp="291wblqbc2k9b">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} className="overflow-hidden rounded-2xl border border-night-line bg-night-panel" data-id="element-63" data-mp="1z3yoj657mtia" data-mpi={index}>
                <h3 data-id="element-64" data-mp="no09mlncpd95">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-start justify-between gap-6 px-6 py-5 text-left font-sans text-base font-semibold text-parchment transition-colors duration-150 ease-out hover:text-gold-soft focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold-soft" data-id="element-65" data-mp="nniextgc773c">
                    {faq.question}
                    <PlusIcon aria-hidden="true" className={`mt-0.5 h-5 w-5 flex-none text-gold-soft transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} data-id="element-66" data-mp="6q57jnds4cl4" />
                  </button>
                </h3>

                <AnimatePresence initial={false} data-id="element-67" data-mp="3jy8b9ahuca0r">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-68" data-mp="3k0cdzp4072zg">
                      <p className="px-6 pb-6 font-sans text-base leading-relaxed text-parchment/70" data-id="element-69" data-mp="1krt90ctds6fr">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}